module.exports = __webpack_public_path__ + "static/beauty-recent-posts-section-9932bc5f9385022a45386320eeb81c75.png";